import React  from 'react';
// import Recaptcha from "react-recaptcha";
//  import Recaptcha from "./recaptcha";
//import { default as Recaptcha } from "./grecaptcha";
//import { default as Recaptcha } from "./recaptcha-auto";
import { default as Recaptcha } from "./recaptcha-explicitly";
import {useAppState} from "../../contexts/app-state";

export default React.forwardRef(
    ({ verifyCallback, setInputValue, error, sitekey}, ref) => {

        const { state } = useAppState();

    return (
        <div>
            <div className="dx-texteditor-container" style={{paddingLeft:3, zIndex:1504}} >
                <Recaptcha ref={ref}
                           verifyCallback={(captchaResponse)=>{
                               if (state.debug) {
                                   console.log('captchaResponse');
                                   console.log(captchaResponse)
                               }
                               if (setInputValue) {
                                   setInputValue('captchaResponse', captchaResponse)
                               }
                               if (verifyCallback) {
                                   verifyCallback(captchaResponse);
                               }
                           }}
                           elementID="g-recaptcha"
                           className="g-recaptcha"
                           onloadCallback={()=>{
                               if (state.debug) {
                                   console.log('captcha loaded');
                               }
                           }}
                           type="image|audio"
                           hl={state.locale}
                           sitekey={state.options.reCAPTCHA.siteKey} />

            </div>
            {error &&
            <div className="dx-invalid-message dx-overlay dx-widget" style={{marginBottom:6}}>
                <div className="dx-invalid-message"
                     data-bind="dxControlsDescendantBindings: true"
                     style={{zIndex: 1503, position: "absolute", width: 310, height: 56, left: 0, top: 0, transform: "translate(0px, -56px)", transition: "all 0s ease 0s"}}>
                    <div className="dx-overlay-content dx-resizable dx-invalid-message-content"
                         style={{width: "auto", height: "auto", zIndex: 1503, margin: 0, left: 0, top: 0, transform: "translate(0px, 56px)", transition: "all 0s ease 0s", maxWidth: 310}}
                    >
                        {error}
                    </div>
                </div>
            </div>}
        </div>
    );
});